import React from "react";

const Store = React.createContext();
Store.displayName = "Store";

export const useStore = () => React.useContext(Store);

export const StoreProvider = ({ children, initialState, reducer, form }) => {
  //Complete Lab Data
  const [globalState, dispatch] = React.useReducer(reducer, initialState);
  const [formValues, dispatchForm] = React.useReducer(
    form.reducer,
    form.initialState
  );
  return (
    <Store.Provider value={{ globalState, dispatch, formValues, dispatchForm }}>
      {children}
    </Store.Provider>
  );
};
